import Column from './Column';
import './Column.scss';

export default Column;
